export const btnDescriptionEnum = {
  general: '請選擇尺寸',
  addBag: '加入購物車',
  soldOut: '已售完',
  preShow: '即將開賣',
  notice: '索取貨到通知',
};

export const btnFoodDescriptionEnum = {
  general: '請選擇規格',
  addBag: '加入購物車',
  soldOut: '已售完',
  preShow: '即將開賣',
  notice: '索取貨到通知',
};

export const btnStockDescriptionEnum = {
  general: '請選擇規格',
  search: '門市庫存查詢',
};

export const btnStyleEnum = {
  disabled: 'disabled',
  activeMail: 'active-mail',
  active: 'active',
};

export const addToCartEnum = {
  addSuccess: '加入購物車',
};
